import { FilterWrapper } from '@screens/Category/ui/Filter/FilterModal/FilterWrapper/FilterWrapper';
import { Metrics } from '@shared/types/enums/metrics.enum';
import { Switch } from '@shared/ui/Switch';
import { sendMetrics } from '@shared/utils/sendMetrics/sendMetrics';

import cls from './FilterSwitch.module.scss';

type SwitchProps = {
  label: string;
  value: boolean;
  onChange: (value: boolean, filterId: string) => void;
  filterId: string;
};

export const FilterSwitch = ({ label, onChange, value, filterId }: SwitchProps) => {
  const onChangeHandler = (checked: boolean) => {
    onChange(checked, filterId);
    sendMetrics(Metrics.FILTER_GOAL);
  };

  return (
    <FilterWrapper
      variant={'switch'}
      className={cls.wrap}
      label={label}
    >
      <Switch
        testId={'filter-switch'}
        onChange={onChangeHandler}
        value={value}
      />
    </FilterWrapper>
  );
};
